import { cry } from 'thor-devkit';

// utility resources
// https://web3js.readthedocs.io/en/1.0/web3-utils.html
// https://github.com/vechain/thor-devkit.js

export function getPrivateKey(words) {
    const byteArray = cry.mnemonic.derivePrivateKey(words);
    return byteArraytoHexString(byteArray);
}

export function getPublicKey(privateKey) {
  return cry.secp256k1.derivePublicKey(privateKey);
}

export function byteArraytoHexString(byteArray) {
    var s = '0x';
    byteArray.forEach(function(byte) {
      s += ('0' + (byte & 0xFF).toString(16)).slice(-2);
    });
    return s;
}

export function vetStringToWei(vet, web3) {
  return web3.utils.toWei(vet, 'ether');
}

export function weiToVetString(wei, web3) {
  return web3.utils.fromWei(wei, 'ether');
}

export function stringToHex(str, web3) {
  return web3.utils.fromAscii(str);
}

export function hexToString(hex, web3) {
  return web3.utils.toAscii(hex);
}

export const rightPad = (string, chars, sign) => {
  const hasPrefix = /^0x/i.test(string) || typeof string === 'number';
  string = string.toString(16).replace(/^0x/i, '');

  const padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;

  return (hasPrefix ? '0x' : '') + string + new Array(padding).join(sign || '0');
};

export const asciiToHex = (str, length = 32) => {
  let hex = '';

  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    const n = code.toString(16);
    hex += n.length < 2 ? `0${n}` : n;
  }

  return '0x' + rightPad(hex, length * 2);
};

export async function getNetType() {
  const block = window.connex.thor.block(0);
  const firstBlock = await block.get();

  return firstBlock.id === '0x000000000b2bce3c70bc649a02749e8687721b09ed2e15997f466536b20bb127' ? 'TEST' : 'MAIN';
}

// ucs-2 string to base64 encoded ascii
export function utoa(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
// base64 encoded ascii to ucs-2 string
export function atou(str) {
  return decodeURIComponent(escape(window.atob(str)));
}